<template>
	<div v-if="url != null && url != ''">
		<vue-pdf-embed :source="url" />
	</div>
</template>

<script>
	import VuePdfEmbed from 'vue-pdf-embed'
	import {
		useI18n
	} from "vue-i18n";
	import {
		useStore
	} from "vuex";
	import {
		systemServiceApi
	} from '../api/index.js'

	export default {
		components: {
			VuePdfEmbed,
		},
		data() {
			return {
				url: '',
				modelId: '',
				motoId: '',
				type: '',
				modelParams: {}
			}
		},
		methods: {
			async findPdfUrl() {
				try {
					if (this.type == 5) {
						// 获取车辆合格证书
						const response = await systemServiceApi.getMotoCertPdf(this.motoId);
						this.url = response.data;
						document.title = "合格证书";
					} else {
						// 获取模型参数
						const response = await systemServiceApi.getModelParams(this.modelId);
						// console.log(JSON.stringify(response.data, null, 2));
						this.modelParams = response.data;
						switch (this.type) {
							case 1:
								this.url = this.modelParams.selfInspectionManual;
								document.title = this.$t('msg.selfTestManual');
								break;
							case 2:
								this.url = this.modelParams.usageGuide;
								document.title = this.$t('msg.usageFuide');
								break;
							case 3:
								this.url = this.modelParams.vehicleDesc;
								document.title = this.$t('msg.vehicleDescription');
								break;
							case 4:
								this.url = this.modelParams.servicePolicy;
								document.title = this.$t('msg.servicePolicy');
								break;
						}
					}
				} catch (error) {
					console.error('获取PDF URL失败:', error);
				}
			},
			async initPlus() {
				try {
					var token = plus.storage.getItem('h5token');
					this.modelId = JSON.parse(this.$route.query.modelId);
					this.motoId = this.$route.query.motoId;
					this.type = JSON.parse(this.$route.query.type);
					// console.log(JSON.stringify(this.$route, null, 2))
					// console.log(this.motoId)
					// console.log(this.type)
					// console.log('获取到的 token:', token);
					// window.uni.onMessage(function(res) {
					// 	console.log('收到原生消息:', res);
					// });
					var lang = this.$route.query.lang;
					
					if (lang != null) {
						const store = useStore();
						const i18n = useI18n();
						i18n.locale.value = lang;
						store.commit("setLanguage", lang);
					}
					
					document.title = this.$t('msg.disclaimer')

					this.findPdfUrl();
					
				} catch (error) {
					console.error('获取PDF URL失败:', error);
				}
			}
		},
		mounted() {
			if (typeof window.plus !== 'undefined') {
				this.initPlus();
			} else {
				// 监听 plusready 事件
				document.addEventListener('plusready', this.initPlus, {
					once: true
				});
			}
		}
	}
</script>